import { Box, Table, Typography } from '@mui/joy';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { post } from '../../../../Script/Session';
import BewertungsCard from '../../VergleichSubKathegorie/Tarif/TarifStandViewer/Tabs/BewertungsCard';
import html2pdf from "html2pdf.js";

function VergleichErgebniss() {
    const location = useLocation();
    const { body, subkathdata, tarifs, n, selectede } = location.state || {};

    const [data, setData] = useState(null);
    const [idob, setIdob] = useState(tarifs);
    const [fragenob, setFragenob] = useState(n);
    const [downloaded, setDownloaded] = useState(false);
    const [debug, setDebug] = useState(false);

    const pdfRef = useRef();

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await post(body, "/vergleichen");
                setData(JSON.parse(response));
                setTimeout(() => {
                    setDebug(true);
                }, 500); // slight delay to ensure rendering
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        }
        fetchData();
    }, []);

    useEffect(() => {
        if (!downloaded && selectede === "PDF" && data && debug) {
            const element = pdfRef.current;
            if (!element) return;

            const opt = {
                margin: 0.3,
                filename: `vergleich.pdf`,
                image: { type: 'jpeg', quality: 1 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: "#ffffff",
                },
                jsPDF: {
                    unit: 'in',
                    orientation: 'landscape',
                },
                pagebreak: {
                    mode: ['css', 'legacy'],
                    avoid: ['tr', 'td', 'th', '.no-break']
                }
            };

            setTimeout(() => {
                try {
                    html2pdf().set(opt).from(element).save();
                    setDownloaded(true);
                } catch (err) {
                    console.error("PDF generation failed:", err);
                }
            }, 500);
        }
    }, [data, debug]);

    function getpoints(idEntry, frageDef) {
        if (!idEntry || !Array.isArray(frageDef.bewertung)) return 0;
        const match = frageDef.bewertung.find((e) => e.id === idEntry.bewertung);
        return match?.point ?? 0;
    }

    if (!debug || !data) return <>Loading...</>;

    return (
        <Box
            ref={pdfRef}
            sx={{
                p: 2,
                width: '100%',
                overflowX: 'auto',
                overflowY: 'visible',
            }}
        >
            <Box sx={{ minWidth: idob.length * 300 }}>
            <Table
                sx={{
                    bgcolor: "white",
                    '& td, & th': {
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        pageBreakInside: 'avoid',
                        breakInside: 'avoid',
                        minWidth: "800px",
                    },
                    "& th": {
                        bgcolor: "#f0f0f0",
                    }
                }}
                stickyHeader
                borderAxis="both"
            >
                <thead>
                    <tr>
                        <th>Frage</th>
                        {idob.map((item) => {
                            const tarif = data?.result.find((i) => i.id === item);
                            return (
                                <React.Fragment key={`header-${item}`}>
                                    <th style={{ width: "5%" }}>Bewertung</th>
                                    <th>{tarif?.gesellschaft || 'Unbekannter Tarif'}</th>
                                </React.Fragment>
                            );
                        })}
                    </tr>
                </thead>

                <tbody>
                    <tr key="tarif-row">
                        <td>Tarif</td>
                        {idob.map((item) => {
                            const tarif = data?.result.find((i) => i.id === item);
                            return (
                                <React.Fragment key={`tarif-${item}`}>
                                    <td style={{ width: "5%" }}>–</td>
                                    <td>{tarif?.name || "–"}</td>
                                </React.Fragment>
                            );
                        })}
                    </tr>

                    <tr key="stand-row">
                        <td>Stand</td>
                        {idob.map((item) => {
                            const tarif = data?.result.find((i) => i.id === item);
                            const date = tarif?.lasttarif?.stempel
                                ? new Date(tarif.lasttarif.stempel).toLocaleDateString()
                                : "–";
                            return (
                                <React.Fragment key={`stand-${item}`}>
                                    <td style={{ width: "5%" }}>–</td>
                                    <td>{date}</td>
                                </React.Fragment>
                            );
                        })}
                    </tr>
                    <tr key={"p-row"}>
                        <td>Gesammt Punkzahl</td>
                        {idob.map((id) => {
                            const tarif = data?.result.find(t => t.id === id);
                            const total = subkathdata.fragen.reduce((acc, item) => {
                                const keys = Object.keys(item).filter(k => k !== "order");
                                const name = keys[0] || "Unbenannt";
                                const fragen = item[name];
                                return acc + fragen.reduce((sum, frage) => {
                                    const idEntry = tarif?.lasttarif?.bewertung?.find((a) => a.question === frage.name);
                                    return sum + getpoints(idEntry, frage);
                                }, 0);
                            }, 0);
                            return (
                                <React.Fragment key={`total-${id}`}>
                                    <td><strong>{total}</strong></td>
                                    <td />
                                </React.Fragment>
                            );
                        })}
                    </tr>
                    {Array.isArray(subkathdata.fragen) &&
                        subkathdata.fragen
                            .slice()
                            .sort((a, b) => a.order - b.order)
                            .map((item, index) => {
                                const keys = Object.keys(item).filter(k => k !== "order");
                                const name = keys[0] || "Unbenannt";
                                const fragen = item[name];

                                return (
                                    <React.Fragment  key={`block-${index}`}>
                                        <tr style={{ backgroundColor: '#f0f0f0' }}>
                                            <td style={{ fontWeight: 'bold' }}>{name}</td>
                                            {idob.map((id) => {
                                                const tarif = data?.result.find(t => t.id === id);
                                                const sum = fragen.reduce((acc, frage) => {
                                                    const idEntry = tarif?.lasttarif?.bewertung?.find((a) => a.question === frage.name);
                                                    return acc + getpoints(idEntry, frage);
                                                }, 0);
                                                return (
                                                    <React.Fragment key={`sum-${id}-${index}`}>
                                                        <td><strong>{sum}</strong></td>
                                                        <td />
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tr>

                                        {fragen
                                            .filter((i) => fragenob?.includes(i.name))
                                            .sort((a, b) => a.order - b.order)
                                            .map((frage, idx) => (
                                                <tr key={`frage-${index}-${idx}`}>
                                                    <td>{frage.name}</td>
                                                    {idob.map((id) => {
                                                        const tarif = data?.result.find(t => t.id === id);
                                                        const idEntry = tarif?.lasttarif?.bewertung?.find((a) => a.question === frage.name);
                                                        const antwort = tarif?.lasttarif?.questions?.find((a) => a.question === frage.name)?.antwort;
                                                        return (
                                                            <React.Fragment key={`antwort-${id}-${frage.name}`}>
                                                                <td style={{ width: "5%" }}>
                                                                    <BewertungsCard id={idEntry} item={frage} />
                                                                </td>
                                                                <td>{antwort || "–"}</td>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </tr>
                                            ))}
                                    </React.Fragment>
                                );
                            })}
                </tbody>
            </Table>
            </Box>

            {idob.map((item) => {
                const tarif = data?.result.find((i) => i.id === item);
                return (
                    <Box sx={{ mt: 5 }} key={`empfehlung-${item}`}>
                        <Typography level="title-sm">Empfehlung von {tarif?.name}</Typography>
                        <Typography>{tarif?.lasttarif?.empfehlung || "Keine Empfehlung verfügbar."}</Typography>
                    </Box>
                );
            })}
        </Box>
    );
}

export default VergleichErgebniss;